<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-right">
							<router-link class="btn GeneralLeave-back btnBack" to="/permisos/nuevo">
							    <font-awesome-icon icon="fa-solid fa-circle-plus" /> Nuevo permiso retribuido / ausencia
							</router-link>
						</div>
						<div class="title">
							<h3>Permisos Retribuidos / Ausencias</h3>
						</div>
					</div>
					<div class="itemList-header">
						<h1>Permisos retribuidos / ausencias</h1>
					</div>
					<div class="itemList-content row">
						<div v-if="permisos.length == 0" class="AdvanceRequest-title col-md-12 NotFound text-center"> No hay resultados </div>
						<section v-else id="no-more-tables" class="col-md-12 text-center">
							<table class="table" id="tblGeneralLeave">
								<thead>
									<tr>
										<th class="colDate">Fecha desde</th>
										<th class="colDate">Fecha hasta</th>
										<th class="colType">Tipo de permiso</th>
										<th class="colType">Estado</th>
										<th class="colAction">Acción</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="permiso in permisos">
										<td class="colDate" data-title="Fecha desde : ">
											{{ formatDate(permiso.fechaDesde) }}
										</td>
										<td class="colDate" data-title="Fecha hasta : ">
											{{ formatDate(permiso.fechaHasta) }}
										</td>
										<td class="colType" data-title="Tipo de permiso : ">
											{{ permiso.descripcionAusencia }}
										</td>
										<td class="colType" data-title="Estado : ">
											{{ permiso.estado }}
										</td>
										<td class="colAction" data-title="Acción : ">
											<router-link 
											v-if="permiso.estado=='En Curso'" 
											:to="`/permisos/editar/${permiso.id}`">
												<font-awesome-icon icon="fa-solid fa-pencil" />
											</router-link>
											<a 
											v-if="permiso.estado=='En Curso'" 
												href="javascript:void(0);" 
												class="btnDelete" 
												@click="borrar(permiso.id)"
											>
												<font-awesome-icon icon="fa-solid fa-times" />
											</a>
											<router-link :to="`/permisos/ver/${permiso.id}`">
												<font-awesome-icon icon="fa-solid fa-eye" />
											</router-link>
											&nbsp;&nbsp;
										</td>
									</tr>
								</tbody>
							</table>
						</section>
					</div>
					<div class="itemList-footer">
						<div class="pagination text-center Generalleave-paging"></div>
					</div>

					<!--
<div class="row text-center mg-25">
    <div class="form-horizontal form-group">
        <div class="col-sm-12 controls log-sec">
            <input type="button" value="Nuevo permiso retribuido / ausencia" id="btnAdd" class="btn btn-success btn-Generalleave" />
        </div>
    </div>
</div>-->
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import Encabezado from "@/components/Encabezado.vue";
    import Footer from "@/components/Footer.vue";

    export default {
        name: "Permisos",
		components: {
            Encabezado,
            Footer,
        },
		data() { 
			return{}
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
		},
		watch:{
			guardadoOK: function(newValue){
				if (newValue){
					this.$toast.open({
						message: "La Solicitud de Permiso se ha borrado correctamente",
						type: "success",
						duration: 1000,
						dismissible: false,
						position: "top",
						onDismiss: this.redireccionListaPermisos
					});
				}
			}
		},
		computed:{
			permisos: function(){
				let permisos = this.$store.state.perfil.permisos || [];
			
				return Array.isArray(permisos)? permisos : [permisos];
			},
			guardadoOK: function(){
				return this.$store.state.guardadoOK;
			},
		},
		methods:{
			borrar: function(id){
				if (confirm('Atención: Borrar Solicitud de Permiso'))
					this.$store.dispatch('borrarPermiso', {'id': id});
			},
			redireccionListaPermisos: function(){
				//router.replace('/permisos');
				this.$store.commit('establecerGuardadoOK', false);
			},
			formatDate: function(date) {
				return this.moment(date).format('DD/MM/YYYY');
			}
		}
    };
</script>

<style>
    @import "../assets/styles/home.css";
</style>
